import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Spicy Vodka Rigatoni',
  source: 'https://homecookingcollective.com/carbones-spicy-rigatoni-vodka-pasta-copycat-recipe/',
  totalTime: time(0, 40),
  servings: 4,
  tags: { type: 'main' },
  ingredients: [
    { name: 'rigatoni', quantity: '8', unit: 'oz' },
    { name: 'unsalted butter', quantity: '4', unit: 'tbsp' },
    { name: 'sweet onion', quantity: '1/2',
      note: 'very finely diced',
    },
    { name: 'water', quantity: '2', unit: 'tbsp' },
    { name: 'salt' },
    { name: 'black pepper' },
    { name: 'garlic', quantity: '3', unit: 'cloves', customUnit: true,
      note: 'finely minced',
    },
    { name: 'Calabrian chili paste', quantity: '1 1/2', unit: 'tsp' },
    { name: 'tomato paste', quantity: '1/4', unit: 'cup' },
    { name: 'vodka', quantity: '1/4', unit: 'cup' },
    { name: 'heavy cream', quantity: '1', unit: 'cup',
      note: 'room temperature',
    },
    { name: 'parmigiano-reggiano', quantity: '1/4', unit: 'cup',
      note: 'grated & loosely packed',
      amountNote: "plus more for topping",
    },
    { name: 'fresh basil' },
  ],
  directions: [
    {
      title: 'Cook pasta',
      bullets: [
        "Bring large pot of salted water to boil",
        "Cook {rigatoni} per package instructions until just before al dente",
        "Reserve {=1 cup} pasta water",
        "Drain pasta",
      ],
    },
    {
      title: 'Soften onions',
      bullets: [
        "In large skillet, melt {unsalted butter} over medium-low heat",
        "Add {sweet onion} & sauté 10 min until soft & translucent (not browned)",
        "Add {water} to deglaze",
        "Cook 5–10 min more until very soft (if onions begin to brown, add splash of water & lower heat)",
        "Season with pinch of {salt}",
      ],
    },
    {
      title: 'Cook aromatics',
      bullets: [
        "Add {garlic} & {Calabrian chili paste}",
        "Saute 1 min",
      ],
    },
    {
      title: 'Cook tomato paste',
      bullets: [
        "Add {tomato paste} over medium heat",
        "Cook 2–3 min, stirring frequently, until paste darkens to brick-red & sticks to pan",
      ],
    },
    {
      title: 'Deglaze with vodka',
      bullets: [
        "Stir in {vodka}",
        "Simmer 1–2 min until most liquid evaporates",
      ],
    },
    {
      title: 'Simmer cream',
      bullets: [
        "Reduce heat to medium-low",
        "Stir in {heavy cream}",
        "Simmer 5–8 min - until sauce coats back of spoon & turns bright orange",
      ],
    },
    {
      title: 'Finish sauce',
      bullets: [
        "Season with {salt}",
        "Reduce heat to low",
        "Stir in {parmigiano-reggiano} & cooked pasta",
        "Loosen with few tbsp reserved pasta water",
        "Reduce 1–2 min until sauce glossy & clings to pasta",
        "Taste & season with {salt} & {black pepper} as needed",
      ],
    },
    {
      title: 'Serve',
      bullets: [
        "Top with {fresh basil} & extra parmigiano-reggiano",
      ],
    },
  ],
};

export default recipe;
